import { render, staticRenderFns } from "./DocketEntryEditorAttachments.vue?vue&type=template&id=5453d1b6&"
import script from "./DocketEntryEditorAttachments.vue?vue&type=script&lang=js&"
export * from "./DocketEntryEditorAttachments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports